<template>
  <div class="error-container">
    <div class="error-box">
      <h3>There is no data for this chart</h3>
      <i aria-hidden="true" class="v-icon material-icons theme--light" style="font-size: 40px;">
        flip_to_back
      </i>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NoData"
  }
</script>

<style scoped>
  .error-container {
    display: flex;
    min-height: 400px;
    flex-direction: column;
    justify-content: center;

    background-color: #fff;
  }

  .error-box {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
</style>
